import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

/**
 * Whether two sets hold the same members.
 *
 * Used by the permission and alert-run approval sheets to decide whether a
 * selection is dirty. Both seed a `Set` from server state and compare the live
 * selection against it, so an identical helper existed in each until sc-1367
 * pulled it here.
 */
export function setsEqual<T>(a: ReadonlySet<T>, b: ReadonlySet<T>): boolean {
  if (a.size !== b.size) return false
  for (const value of a) {
    if (!b.has(value)) return false
  }
  return true
}
